"use strict";
/**
 * @module "ethpm/session"
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Query = void 0;
class Query {
    constructor(options) {
        this.package = options.package;
        this.workspace = options.workspace;
    }
    scope(dependencyName) {
        return __awaiter(this, void 0, void 0, function* () {
            const dependency = yield this.buildDependency(dependencyName);
            const resolver = new Query({
                package: dependency,
                workspace: this.workspace,
            });
            return resolver;
        });
    }
    contractType(ref) {
        return __awaiter(this, void 0, void 0, function* () {
            const terms = ref.split(':');
            const packages = terms.slice(0, -1);
            const type = terms.slice(-1);
            const [dependencyName, ...rest] = packages;
            if (dependencyName) {
                const subquery = yield this.scope(dependencyName);
                const innerRef = [...rest, type].join(':');
                return yield subquery.contractType(innerRef);
            }
            // plain type reference
            return this.package.contractTypes[ref];
        });
    }
    contractInstance(chain, name) {
        return __awaiter(this, void 0, void 0, function* () {
            const deployment = this.package.deployments.get(chain);
            if (deployment === undefined) {
                throw new Error(`Could not find deployment at chain ${chain.href}`);
            }
            const instance = deployment[name];
            if (instance === undefined) {
                throw new Error(`Could not find instance "${name}" on chain ${chain.href}`);
            }
            return instance;
        });
    }
    buildDependency(name) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!('storage' in this.workspace)) {
                throw new Error('Storage not configured!');
            }
            if (!('manifests' in this.workspace)) {
                throw new Error('Manifests not configured!');
            }
            const workspace = this.workspace;
            const uri = this.package.buildDependencies[name];
            const contents = yield workspace.storage.read(uri);
            if (contents !== undefined) {
                return yield workspace.manifests.read(contents);
            }
            throw new Error(`Could not find build dependency "${name}"`);
        });
    }
}
exports.Query = Query;
